module.exports = __webpack_public_path__ + "static/media/taskListIcon.c039774e.svg";